import { api, environment } from "../../environments/environment";
import { ProjectCardComponent } from "../manager/projectCard.component";
import { BandiCardComponent } from "../manager/bandiCard.component";
import { UniversalCrud, UniversalDetail } from "./universal.model";
import { ImportNoticeCSVComponent } from "../tables-custom-actions/import-notice-csv.component";
import { CatalogCardComponent } from "../manager/catalogCard.component";
import { CreateNoticeComponent } from "../tables-custom-actions/create-notice.component";
import { CustomCatalogFilterComponent } from "../tables-custom-actions/custom-catalog-filter";
import { GoCompaniesComponent } from "../tables-custom-actions/go-companies.component";
import { DwCallCSVComponent } from "../tables-custom-actions/dw-call.component";
import { OpenModalBookingComponent } from "../tables-custom-actions/open-modal-booking.component";
import { NoticeVerificationAdminComponent } from "../tables-custom-actions/notice-verification-admin.component";
import { DownloadRequestsCSVComponent } from "../tables-custom-actions/download-requests-csv.component";
import { ApprovePartnerComponent } from "../tables-custom-actions/approve-partner.component";
import { FixRequestAmmissibilityComponent } from "../tables-custom-actions/fix-request-ammissibility.component";
import { ForceResetEmailComponent } from "../tables-custom-actions/force-reset-email.component";


export const bookings: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  customActions:[
    {component:DwCallCSVComponent,
       label: "Scarica appuntamenti",
      translateLabel: false
    }
  ],
  customExtraComponent:OpenModalBookingComponent,
  breadcrumb: [
    {
      title: "eventi",
      route: "/eventi"
    }
  ],
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    
    {
      element: "ownerId",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "number",
      tableElementToVisualize:[{paths:['owner','firstName'],useFixedValue:false,isObject:false},{paths:[' '],useFixedValue:true,isObject:false},{paths:['owner','lastName'],useFixedValue:false,isObject:false}],
    },
    {
      element: "userId",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "select",
      selectDataEndpoint:'/operator',
      bindLabelSelect:'firstName',
      bindValueSelect:'id',
      tableElementToVisualize:[{paths:['user','firstName'],useFixedValue:false,isObject:false},{paths:[' '],useFixedValue:true,isObject:false},{paths:['user','lastName'],useFixedValue:false,isObject:false}]
    },
    {
      element: "startDate",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "date"
    },
    {
      element: "endDate",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "date"
    },
    {
      element: "noticeId",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "number",
      tableElementToVisualize:[{paths:['notice','title'],useFixedValue:false,isObject:false}]
    },
    {
      element: "categoryId",
      table: true,
      editable: false,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      tableElementToVisualize:[{paths:['category','name'],useFixedValue:false}],
      selectDataEndpoint:'/category/list',
      bindLabelSelect:'name',
      bindValueSelect:'id'
    },
    
    {
      element: "url",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
 
      ],
  endpoint: "/booking",
  canAddElement: false,
  canEditElement: true,
  canDeleteElement: true
};

export const categories: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  useFormData:true,
  breadcrumb: [
    {
      title: "categorie",
      route: "/categorie"
    }
  ],
  tableTitle:'categorie',
  table: [
    {
      element: "image",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      tableElementToVisualize:[{paths:['uploads/'],useFixedValue:true,isObject:false},{paths:['image'],useFixedValue:false,isObject:false}],
      type: "image"
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text"
    },
    
      ],
  endpoint: "/category",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const catalog: UniversalCrud = {
  customTable: CatalogCardComponent,
  customFilters: CustomCatalogFilterComponent,
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "catalogo",
      route: "/catalogo"
    }
  ],
  tableTitle: 'catalogo',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "userId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text"
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "textarea"
    },
    {
      element: "image",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      tableElementToVisualize:[{paths:['uploads/'],useFixedValue:true,isObject:false},{paths:['image'],useFixedValue:false,isObject:false}],
      type: "image"
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },

  ],
  endpoint: "/catalog",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false
};

export const catalogAdmin: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "catalogo",
      route: "/catalogo"
    }
  ],
  tableTitle:'catalogo',
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text"
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "textarea"
    },
    {
      element: "categoryId",
      table: false,
      editable: false,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "multiselect",
      tableElementToVisualize:[{paths:['category','name'],useFixedValue:false,isObject:false}],
      selectDataEndpoint:'/category/list',
      bindLabelSelect:'name',
      bindValueSelect:'id'
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select",
      translateValue:true,
      prefixTranslateValue:'typeCatalog.',
      selectArray:[
        {
          value: 1,
          label: "Azienda"
        },{
          value: 2,
          label: "Servizio"
        },
        {
          value: 3,
          label: "Consulenza"
        }
      ]
    },
    
      ],
  endpoint: "/catalog",
  customEndpoints:{
    read:'/catalog/partner',
    create:"/catalog",
    update:"/catalog",
    delete:"/catalog"
  },
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
  useFormData:true
};

export const partners: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "partners",
      route: "/partners"
    }
  ],
  tableTitle:'partner',
  table:[
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "dateOfBirth",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date"
    },
    {
      element: "role",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    
      ],
  endpoint: "/tech",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true,
};

export const partnersToApprove: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "partners",
      route: "/partners"
    }
  ],
  customTableActions:[{
    icon:'assets/bars-solid.svg',
    iconClass:'',
    component:ApprovePartnerComponent
  }],
  tableTitle:'partner',
  table:[
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "firstCatalog",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      tableElementToVisualize:[{paths:['firstCatalog','name'],useFixedValue:false,isObject:false}],
      type: "text"
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "dateOfBirth",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "date"
    },
    {
      element: "createdAt",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: true,
      obligatory: false,
      type: "date"
    },
    
      ],
  endpoint: "/user/admin/pending",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
};


export const requests: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  elementToRemove:['firstName','lastName'],
  breadcrumb: [
    {
      title: "richieste",
      route: "/richieste"
    }
  ],
  tableTitle:'richieste',
  table: [
    {
      element: "userId",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "select",
      selectDataEndpoint:'/user/list',
      bindLabelSelect:'fullname',
      bindValueSelect:'id',
      tableElementToVisualize:[{paths:['user','fullname'],useFixedValue:false,isObject:false}]
    },{
      element: "techId",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "select",
      tableElementToVisualize:[{paths:['tech','fullname'],useFixedValue:false,isObject:false}],
      selectDataEndpoint:'/tech/list',
      bindLabelSelect:'fullname',
      bindValueSelect:'id',
    },
    {
      element: "catalogId",
      table: true,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "select",
      tableElementToVisualize:[{paths:['catalog','name'],useFixedValue:false,isObject:false}],
      selectDataEndpoint:'/catalog/list',
      bindLabelSelect:'name',
      bindValueSelect:'id'
    },
    {
      element: "createdAt",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "date",
    },
    
      ],
  endpoint: "/request",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
};

export const noticeAdmissibilityRequest: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  elementToRemove:['firstName','lastName'],
  breadcrumb: [
    {
      title: "richieste",
      route: "/richieste"
    }
  ],
  customActions:[{
    label:'Esporta cronologia',
    component:DownloadRequestsCSVComponent,
    translateLabel:false
  }],
  customExtraComponent:FixRequestAmmissibilityComponent,
  tableTitle:'richieste',
  table: [
    {
      element: "userName",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "createdAt",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "date",
    },
    {
      element: "canParticipate",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "boolean",
    },
    {
      element: "motivation",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "reasoning",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "companyName",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "partitaIva",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text",
    },
    {
      element: "notice",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: true,
      tableElementToVisualize:[{paths:['notice','title'],useFixedValue:false,isObject:false}],
      type: "text",
    },
    
      ],
  endpoint: "/notice-admissibility-request",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false,
};

export const partner: UniversalDetail = {
  environment: environment,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "partner",
      route: "/partner"
    }
  ],
  details: [
    {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    
    {
      element: "dateOfBirth",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date"
    },

  ],
  tables: [{
    name: "products",
    active: true,
    endpoint: "products",
    useFormData: true,
    canAddElement: false,
    canEditElement: false,
    customActions: [{
      component: GoCompaniesComponent,
      label: "Modifica aziende",
      translateLabel: false
    }],
    canDeleteElement: true,
    table: [
       {
        element: "name",
        table: true,
        editable: true,
        creation: true,
        filterable: true,
        operator: true,
        obligatory: false,
        type: "text"
      },
      {
        element: "description",
        table: true,
        editable: true,
        creation: true,
        filterable: true,
        operator: true,
        obligatory: false,
        type: "textarea"
      },
      {
        element: "image",
        table: false,
        editable: true,
        creation: true,
        filterable: true,
        operator: true,
        obligatory: false,
        tableElementToVisualize:[{paths:['uploads/'],useFixedValue:true,isObject:false},{paths:['image'],useFixedValue:false,isObject:false}],
        type: "image"
      },
     
      {
        element: "type",
        table: true,
        editable: true,
        creation: true,
        filterable: true,
        operator: true,
        obligatory: true,
        type: "select",
        translateValue:true,
        prefixTranslateValue:'companyType.',
        selectArray: [
          {
            value: 1,
            label: "Azienda"
          }, {
            value: 2,
            label: "Servizio"
          },
          {
            value: 3,
            label: "Consulenza"
          }
        ]
      },
      {
        element: "categoryId",
        table: true,
        editable: false,
        creation: true,
        filterable: true,
        operator: true,
        obligatory: true,
        type: "multiselect",
        tableElementToVisualize:[{paths:['category','name'],isObject:false,useFixedValue:false}],
        selectDataEndpoint: '/category/list',
        bindLabelSelect: 'name',
        bindValueSelect: 'id'
      },

    ]
  }],
  endpoint: "/tech",
  currentBreadcrumb: 0
};

export const companies:UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  useUrl:true,
  use24h: true,
  breadcrumb: [
    {
      title: "aziende",
      route: "/prodotti"
    }
  ],
  tableTitle:'aziende',
  endpoint: "/request",

    useFormData:true,
    canAddElement: true,
    canEditElement: true,
    canDeleteElement: true,
    table: [
      {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "textarea"
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
      {
      element: "image",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      tableElementToVisualize:[{paths:['uploads/'],useFixedValue:true,isObject:false},{paths:['image'],useFixedValue:false,isObject:false}],
      type: "image"
    },
    {
      element: "logo",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      tableElementToVisualize:[{paths:['uploads/'],useFixedValue:true,isObject:false},{paths:['logo'],useFixedValue:false,isObject:false}],
      type: "image"
    },
    {
      element: "website",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "specializations",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "references",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "certifications",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "eProcurement",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
     {
      element: "categories",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "multiselect",
      tableElementToVisualize:[{paths:['categories'],useFixedValue:false,isObject:true}],
      selectDataEndpoint:'/category/list',
      bindLabelSelect:'name',
      bindValueSelect:'id'
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "select", translateValue:true,
        prefixTranslateValue:'companyType.',
      selectArray:[
        {
          value: 1,
          label: "Azienda"
        },{
          value: 2,
          label: "Servizio"
        },
        {
          value: 3,
          label: "Consulenza"
        }
      ]
    },
   
    {
      element: "businessDescription",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "textarea"
    }
      ]
}

export const dates: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "date",
      route: "/date"
    }
  ],
  tableTitle:'date',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "date",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date"
    },
    {
      element: "open",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
     type: "select",
          selectArray: [
            { value: false, label: "No" },
            { value: true, label: "Si" },
          ],
    },
    
      ],
  endpoint: "/dates",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const documents: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  useFormData:true,
  use24h: true,
  breadcrumb: [
    {
      title: "documenti",
      route: "/documenti"
    }
  ],
  tableTitle:'documenti',
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "file",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "file"
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      prefixTranslateValue:'daysOfTheWeek.',
      type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
    },
    
    
  ],
  endpoint: "/document",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const notices: UniversalCrud = {
  customTable: BandiCardComponent,
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  details:{route:'dettaglio-bando'},
  breadcrumb: [
    {
      title: "bandi",
      route: "/bandi"
    }
  ],
  tableTitle:'bandi',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "textarea"
    },
    {
      element: "endDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date"
    },
    {
      element: "startDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date"
    },
      ],
  endpoint: "/notice",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false
};

export const noticesAdmin: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  usePageCreation:{
    route:'createNoticeAdmin'
  },
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  customActions:[{
    component: ImportNoticeCSVComponent,
    label: 'Importa da csv',
    translateLabel: false
  }
],
customTableActions:[
  { component:NoticeVerificationAdminComponent,icon:'assets/bars-solid.svg',iconClass:''}
],
  details:{route:'adminDetailNotice'},
  breadcrumb: [
    {
      title: "bandi",
      route: "/bandi"
    }
  ],
  tableTitle:'bandi',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "title",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "source",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "text",
    },
    {
      element: "agevolazioneConcedibileMax",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "number"
    },{
      element: "agevolazioneConcedibileMin",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "number"
    },{
      element: "altreCaratteristiche",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "ambitoTerritoriale",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "baseNormativaPrimaria",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "baseNormativaSecondaria",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "codiciAteco",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "comuni",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "costiAmmessi",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "dataUltimoAggiornamento",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "datetime-local"
    },{
      element: "desc1",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "desc2",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "desc3",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "dimensioni",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "formaAgevolazione",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "gazzettaUfficiale",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "linkIstituzionale",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "noteAperturaChiusura",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "obiettivoFinalita",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "provvedimentoAttuativo",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "regioni",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "settoreAttivita",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "soggettoConcedente",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },{
      element: "spesaAmmessaMax",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "number"
    },{
      element: "spesaAmmessaMin",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "number"
    },{
      element: "stanziamentoIncentivo",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "number"
    },{
      element: "tipologiaSoggetto",
      table: false,
      editable: true,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: true,
      type: "text"
    },
    {
      element: "startDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "datetime-local"
    },
    {
      element: "endDate",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "datetime-local"
    },
      ],
  endpoint: "/notice",
  canAddElement: true,
  canEditElement: false,
  canDeleteElement: true
};

export const noticeDetailsAdmin: UniversalDetail = {
  route:'adminDetailNotice',
  environment: environment,
  api: api,
  stepMinutes: 5,
  useFormData:false,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "bandi",
      route: "/bandi"
    }
  ],
  details: noticesAdmin.table,
  tables:[
    {
    name: "categories",
    active: true,
    endpoint: "categories",
    canAddElement: false,
    canEditElement: true,
    canDeleteElement: true,
    table: [
   {
      element: "categoryId",
      table: true,
      editable: false,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      tableElementToVisualize:[{paths:['category','name'],useFixedValue:false,isObject:false}],
      selectDataEndpoint:'/category/list',
      bindLabelSelect:'name',
      bindValueSelect:'id'
    }, ]
  },
 {
    name: "documents",
    active: false,
    endpoint: "notice-document",
    customEndpoints:{
      create:['notice-document','mainTableId'],
      read:['notice-document','mainTableId'],
      update:['notice-document','subTableId'],
      delete:['notice-document','subTableId']
    },
    canAddElement: true,
    useFormData:true,
    canEditElement: true,
    canDeleteElement: true,
    table: [
      {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
      {
      element: "file",
      table: false,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "image"
    }
   
      ]
  }],
  endpoint: "/notice",
  currentBreadcrumb: 0
};

export const payments: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "pagamento",
      route: "/pagamenti"
    }
  ],
  tableTitle:'pagamento',
  table: [
    {
      element: "userId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "payed",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
          selectArray: [
            { value: 0, label: "No" },
            { value: 1, label: "Si" },
          ],
    },
    {
      element: "timestamp",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "datetime"
    },
    {
      element: "platform",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "code",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "planId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    
    
      ],
  endpoint: "/payment",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const permissions: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "permesso",
      route: "/permessi"
    }
  ],
  tableTitle:'permesso',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "entity",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text"
    },
    {
      element: "action",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "date"
    },
    
      ],
  endpoint: "/permission",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const plans: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "piano",
      route: "/piani"
    }
  ],
  tableTitle:'piano',
  table: [
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text"
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "textarea"
    },
    {
      element: "view",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
      translateValue:true,
    },
    {
      element: "comingSoon",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      translateValue:true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "type",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "duration",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "fundraising",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "virtualroom",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "dbUpartner",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "virtualroomUpartner",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "proposalManagement",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "projectManagement",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "price",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "netprice",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "varprice",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
    {
      element: "showcaseUpartner",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      translateValue:true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "manageService",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      translateValue:true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "webinar",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      translateValue:true,
      selectArray: [
        { value: false, label: "No" },
        { value: true, label: "Si" },
      ],
    },
    {
      element: "contracts",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
      ],
  endpoint: "/plan",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const projects: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  customTable: ProjectCardComponent,
     details: {
     route: 'project',
},
  breadcrumb: [
    {
      title: "progetto",
      route: "/progetti"
    }
  ],
  tableTitle:'progetto',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "userId",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "number"
    },
  ],
  endpoint: "/project",
  canAddElement: false,
  canEditElement: false,
  canDeleteElement: false
};

export const projectsAdmin: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  details: {
     route: 'project',
},
  breadcrumb: [
    {
      title: "progetto",
      route: "/progetti"
    }
  ],
  tableTitle:'progetto',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "firstName",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      tableElementToVisualize:[{paths:['user','firstName'],useFixedValue:false,isObject:false}],
      type: "text"
    },
    {
      element: "lastName",
      table: true,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: false,
      tableElementToVisualize:[{paths:['user','lastName'],useFixedValue:false,isObject:false}],
      type: "text"
    },
  ],
  endpoint: "/project",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const roles: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "ruolo",
      route: "/ruoli"
    }
  ],
  tableTitle:'ruolo',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "name",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "text"
    },
    {
      element: "description",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "textarea"
    },
    
      ],
  endpoint: "/role",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const timetables: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "tabella temporale",
      route: "/tabelle_temporali"
    }
  ],
  tableTitle:'tabella temporale',
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
    {
      element: "day",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      translateValue:true,
      prefixTranslateValue:'daysOfTheWeek.',
      type: "select",
          selectArray: [
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ],
    },
    {
      element: "timeStart",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "time",
    },
    {
      element: "timeEnd",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "time",
    },
    {
      element: "from",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "date"
    },
    
      ],
  endpoint: "/timetables",
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: true
};

export const user: UniversalCrud = {
  environment: environment,
  isPaginated: true,
  api: api,
  stepMinutes: 5,
  showClock: true,
  use24h: true,
  breadcrumb: [
    {
      title: "utente",
      route: "/utenti"
    }
  ],
  tableTitle:'utente',
  customTableActions:[{
    icon:'assets/reset.svg',
    component:ForceResetEmailComponent,
    iconClass:''
  }],
  table: [
    {
      element: "id",
      table: false,
      editable: false,
      creation: false,
      filterable: true,
      operator: true,
      obligatory: true,
      type: "number"
    },
     {
      element: "firstName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "lastName",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "email",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "text"
    },
    {
      element: "companyName",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      tableElementToVisualize:[{paths:['profile','ragioneSociale'],useFixedValue:false,isObject:false}],
      type: "text",
    },
    {
      element: "createdAt",
      table: true,
      editable: false,
      creation: false,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "date",
    },
    {
      element: "parentId",
      table: false,
      editable: false,
      creation: true,
      filterable: false,
      operator: false,
      obligatory: false,
      type: "select",
      selectDataEndpoint:"/user?options={%22page%22:1,%22limit%22:9999,%22filters%22:[{%22s%22:%22role%22,%22v%22:2,%22o%22:1}]}",
      bindLabelSelect:'ragioneSociale',
      bindValueSelect:'id',
      tableElementToVisualize:[{paths:['data','firstName'],useFixedValue:false,isObject:false},{paths:[' '],useFixedValue:true,isObject:false},{paths:['data','lastName'],useFixedValue:false,isObject:false}],
    },
    {
      element: "role",
      table: true,
      editable: true,
      creation: true,
      filterable: true,
      operator: true,
      obligatory: false,
      type: "select",
      translateValue:true,
      prefixTranslateValue:'roles.',
      selectArray:[{
        value:0,
        label:'Ospite'
      },{
        value:1,
        label:'Operatore'
      },{
        value:2,
        label:'Imprese e startup'
      },{
        value:3,
        label:'PMI'
      },{
        value:4,
        label:'Enti Pubblici'
      },{
        value:5,
        label:'Admin'
      },{
        value:6,
        label:'Partner'
      },{
        value:7,
        label:'Dipendente'
      }
    ]
    },
    
      ],
  endpoint: "/user",
  customEndpoints:{
    create:"/user/create",
    read:"/user",
    update:"/user",
    delete:"/user"
  },
  canAddElement: true,
  canEditElement: true,
  canDeleteElement: false
};
